import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import PaymentList from './PaymentList';

//redux

const Payment = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio', icon: 'icon-house'}];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Estados de Pagos' links={breadcrumbLinks} icon={'icon-circle-dollar-sign'} />
					<PaymentList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Payment;
